import { DatePicker as _DatePicker } from 'antd';
import { DateTime } from 'luxon';
import luxonGenerateConfig from 'rc-picker/lib/generate/luxon';

export const DatePicker =
	_DatePicker.generatePicker<DateTime>(luxonGenerateConfig);
